"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCanvasContext2D = createCanvasContext2D;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.removeChildren = removeChildren;
exports.removeNode = removeNode;
exports.replaceChildren = replaceChildren;
exports.replaceNode = replaceNode;

var _has = require("./has.js");

/**
 * @module ol/dom
 */
//FIXME Move this function to the canvas module

/**
 * Create an html canvas element and returns its 2d context.
 * @param {number} [opt_width] Canvas width.
 * @param {number} [opt_height] Canvas height.
 * @param {Array<HTMLCanvasElement>} [opt_canvasPool] Canvas pool to take existing canvas from.
 * @param {CanvasRenderingContext2DSettings} [opt_Context2DSettings] CanvasRenderingContext2DSettings
 * @return {CanvasRenderingContext2D} The context.
 */
function createCanvasContext2D(opt_width, opt_height, opt_canvasPool, opt_Context2DSettings) {
  /** @type {HTMLCanvasElement|OffscreenCanvas} */
  var canvas;

  if (opt_canvasPool && opt_canvasPool.length) {
    canvas = opt_canvasPool.shift();
  } else if (_has.WORKER_OFFSCREEN_CANVAS) {
    canvas = new OffscreenCanvas(opt_width || 300, opt_height || 300);
  } else {
    canvas = document.createElement('canvas');
  }

  if (opt_width) {
    canvas.width = opt_width;
  }

  if (opt_height) {
    canvas.height = opt_height;
  } //FIXME Allow OffscreenCanvasRenderingContext2D as return type


  return (
    /** @type {CanvasRenderingContext2D} */
    canvas.getContext('2d', opt_Context2DSettings)
  );
}
/**
 * Get the current computed width for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerWidth(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The width.
 */


function outerWidth(element) {
  var width = element.offsetWidth;
  var style = getComputedStyle(element);
  width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
  return width;
}
/**
 * Get the current computed height for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerHeight(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The height.
 */


function outerHeight(element) {
  var height = element.offsetHeight;
  var style = getComputedStyle(element);
  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
}
/**
 * @param {Node} newNode Node to replace old node
 * @param {Node} oldNode The node to be replaced
 */


function replaceNode(newNode, oldNode) {
  var parent = oldNode.parentNode;

  if (parent) {
    parent.replaceChild(newNode, oldNode);
  }
}
/**
 * @param {Node} node The node to remove.
 * @return {Node|null} The node that was removed or null.
 */


function removeNode(node) {
  return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
/**
 * @param {Node} node The node to remove the children from.
 */


function removeChildren(node) {
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
}
/**
 * Transform the children of a parent node so they match the
 * provided list of children.  This function aims to efficiently
 * remove, add, and reorder child nodes while maintaining a simple
 * implementation (it is not guaranteed to minimize DOM operations).
 * @param {Node} node The parent node whose children need reworking.
 * @param {Array<Node>} children The desired children.
 */


function replaceChildren(node, children) {
  var oldChildren = node.childNodes;

  for (var i = 0; true; ++i) {
    var oldChild = oldChildren[i];
    var newChild = children[i]; // check if our work is done

    if (!oldChild && !newChild) {
      break;
    } // check if children match


    if (oldChild === newChild) {
      continue;
    } // check if a new child needs to be added


    if (!oldChild) {
      node.appendChild(newChild);
      continue;
    } // check if an old child needs to be removed


    if (!newChild) {
      node.removeChild(oldChild);
      --i;
      continue;
    } // reorder


    node.insertBefore(newChild, oldChild);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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